/**
 * Find Facebook friends
 *
 * @param {int} limit
 * @param {int|null} cursor
 * @return {Promise<any>}
 */
export const findFacebookFriends = (limit = 5, filters, cursor = null) => {
    const {
        REACT_APP_FACEBOOK_APP_ID: facebookAppId,
        REACT_APP_API_URL: apiUrl,
    } = window.APP_CONFIG
    const loggedWith = JSON.parse(localStorage.getItem('loggedUser'))?.loggedWith || ''

    if (loggedWith !== 'facebook') {
        return new Promise(resolve => resolve())
    }

    const filtersUrl = filters && Object.keys(filters).length > 0 ? `&${queryString.stringify(filters)}` : ''

    return window.axios
        .post(`${apiUrl}api/users/fb-friends?include=sportnectionStatus,cheers&limit=${limit}&cursor=${cursor}${filtersUrl}`, {
            appId: facebookAppId,
        })
        .then(response => response.data)

}
